// = Libs =
import { FC, useState } from 'react';

// = Containers & Components =
import { SplitContent } from '@/common/containers/split-content/split-content';
import Container from '@/common/containers/container/container';
import { useParams } from 'react-router-dom';
import { CalendarState } from '@/common/components/ui/calendar/calendar';
import { ReportCardModel, useReports } from '@/services/report.service';
import { SideBar } from '@/pages/poll/author-poll/tabs/poll-reports/reports-side-bar';
import ReportCard from '@/pages/poll/author-poll/tabs/poll-reports/report-card/report-card';

const PollReports: FC = () => {
  const { id } = useParams<{ id: string }>();

  const [state, setState] = useState<CalendarState>({
    startDate: null,
    endDate: null,
  });

  const answers = useReports(id) || {
    total: 0,
    count: 0,
    elementList: [],
  };

  return (
    <Container>
      <SplitContent
        SideBar={
          <SideBar
            state={state}
            dispatcher={setState}
            canAdd={false}
            canDownload={true}
          />
        }
        Content={
          <div>
            {answers?.elementList?.map((el: ReportCardModel) => (
              <ReportCard {...el} key={el.id} />
            ))}
          </div>
        }
        Position={false}
      />
    </Container>
  );
};

export default PollReports;
